import loaderClient, {
  clientNoLoader,
  loaderWithSetter,
} from "api/reduxLoaderApi";
import { toast } from "react-toastify";
import { setAirlineSetting } from "store/slices/airline/airlineSlice";
import {
  setCountriesInUser,
  setCurrencyCodes,
  setDepartment,
  setDepartmentsFilters,
  setGeneralSettingForm,
  setPositions,
} from "./generalSettingSlice";
import { selAirlineId } from "store/slices";

export const getAirlineSettings =
  (id, callback) => async (dispatch, getState) => {
    let airlineId = id ?? selAirlineId(getState());
    const client = loaderClient("get")(`/airlines/${airlineId}/settings`);
    const res = await client({})({});
    if (res.error) return;
    console.log("resssss", res.message);
    dispatch(setAirlineSetting(res.message));
    return callback && callback(res.message);
  };

export const updateAirlineSettings =
  (settingsId, body, callback) => async (dispatch) => {
    const client = clientNoLoader("patch")(`/airline-settings/${settingsId}`);
    const res = await client(body)({});
    if (res.error) {
      callback?.(res.error);
      return;
    }
    toast.success("Flight status updated successfully!");
    dispatch(setAirlineSetting(res.message));
    return callback?.(res.error);
  };

export const patchAirlineGeneralSetting =
  (data, callback = false) =>
  // console.log('patchAirlineGeneralSetting',id)
  async (dispatch, getState) => {
    console.log("test data 1", data);
    const id = selAirlineId(getState());
    const client = loaderClient("patch")(`airlines/general-setting/${id}`);
    const res = await client({ ...data })({});
    console.log("client_", res);
    callback && callback(res.error, res.message);
    // res.error?  :  toast.success("General setting edited successfully");
  };

export const editAirlineSeatClass =
  (id, data, callback = false) =>
  async (dispatch) => {
    const client = loaderClient("patch")(
      `/airline-settings/${id}/seat-classes`
    );
    const res = await client(data)({});
    if (res.error) return;
    return callback && callback();
  };

export const createAirlineSeatClass =
  (id, data, callback = false) =>
  async (dispatch) => {
    const client = loaderClient("post")(`/airline-settings/${id}/seat-classes`);

    const res = await client(data)({});
    if (res.error) return;
    return callback && callback();
  };

export const deleteAirlineSeatClass =
  (id, classCode, callback = false) =>
  async (dispatch) => {
    const client = loaderClient("delete")(
      `/airline-settings/${id}/seat-classes`
    );
    const res = await client({ classCode })({});
    if (res.error) return;
    return callback && callback();
  };

export const getCurrencyCodes = (id) => async (dispatch) => {
  const client = loaderClient("get")(`currency-codes`);
  const res = await client({})({});
  if (res.error) return toast.error(res.message.cu);
  dispatch(setCurrencyCodes(res.message.currencies));
};

export const getDepartment =
  (query, filters, callback) => async (dispatch, getState) => {
    let airlineId = selAirlineId(getState());
    let params = `airline=${airlineId}`;
    if (query) params += `&${query}`;
    const client = loaderClient("get")(`/departments?${params}`);
    const res = await client({})({});
    dispatch(setDepartmentsFilters(filters));
    if (!res.error) {
      dispatch(setDepartment(res));
    }
    return callback && callback(res.error, res.message);
  };

export const createDepartment = (data, callback) => async (dispatch) => {
  const client = loaderClient("post")(`/departments`);
  const res = await client(data)({});
  return callback && callback(res.error, res.message);
};

export const updateDepartment = (id, data, callback) => async (dispatch) => {
  const client = loaderClient("patch")(`/departments/${id}`);
  const res = await client(data)({});
  return callback && callback(res.error, res.message);
};

export const deleteDepartment = (id, callback) => async (dispatch) => {
  const client = loaderClient("delete")(`/departments/${id}?softDelete=false`);
  const res = await client({})({});
  return callback && callback(res.error, res.message);
};

export const getAirlinePositions = (query, callback) => async (dispatch) => {
  const client = loaderClient("get")(
    `/v2/airline-positions${query ? `?${query}` : ""}`
  );
  const res = (await client({})({})) || {
    error: true,
    message: "Unable to load airline positions.",
  };
  if (!res.error) dispatch(setPositions(res));
  callback?.(res.error, res.message);
  return res;
};

export const getPositionUserAssignments = (callback) => async (dispatch) => {
  const client = loaderClient("get")(
    "/v2/user-assignments?limit=all&sortBy=known_as:asc"
  );
  const res = (await client({})({})) || {
    error: true,
    message: "Unable to load users.",
  };
  callback?.(res.error, res.message || []);
  return res;
};

export const createAirlinePosition = (data, callback) => async (dispatch) => {
  const client = loaderClient("post")("/v2/airline-positions");
  const res = (await client(data)({})) || {
    error: true,
    message: "Unable to create airline position.",
  };
  callback?.(res.error, res.message);
  return res;
};

export const updateAirlinePosition =
  (id, data, callback) => async (dispatch) => {
    const client = loaderClient("patch")(`/v2/airline-positions/${id}`);
    const res = (await client(data)({})) || {
      error: true,
      message: "Unable to update airline position.",
    };
    callback?.(res.error, res.message);
    return res;
  };

export const deleteAirlinePosition = (id, callback) => async (dispatch) => {
  const client = loaderClient("delete")(`/v2/airline-positions/${id}`);
  const res = (await client({})({})) || {};
  callback?.(res.error, res.message);
  return res;
};

export const getCountries = (setter, search) => async (dispatch) => {
  let searchValue = search?.replace("+", "");
  searchValue = searchValue?.replace("(", "");
  searchValue = searchValue?.replace(")", "");
  if (!search || searchValue?.length < 2) return;
  const res = await loaderWithSetter(setter)("get")(`/countries`)({
    params: {
      search: searchValue,
    },
  })({});
  if (res.error) return;
  return dispatch(setCountriesInUser(res.message));
};
